/**
 * Registra solo `single-spa` antes de `System.import('@ubits-mf/root-config')`.
 * La URL se inyecta en build con DefinePlugin (`__SINGLE_SPA_SYSTEMJS_URL__`) desde
 * `shared-importmap.imports.json` para no dejar el JSON completo ni un literal largo en el chunk.
 */

import { addSystemImportMap } from './system-importmap-helpers'

declare const __SINGLE_SPA_SYSTEMJS_URL__: string

export function registerSingleSpaImportMap(): void {
  addSystemImportMap({
    imports: {
      'single-spa': __SINGLE_SPA_SYSTEMJS_URL__,
    },
  })
}
